module.exports = __webpack_public_path__ + "img/app-logo.39230717.png";